import type {
  WPProductConfig,
  WPProductLinkConfig} from "../../models/WPProductConfig";
import {
  WPProductTypes,
} from "../../models/WPProductConfig";

export function isProduct(
  product: WPProductConfig | WPProductLinkConfig,
): product is WPProductConfig {
  return product.type === WPProductTypes.PRODUCT;
}
